import Vue from "vue";
import TitleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
import { mapGetters } from "vuex";
export default Vue.extend({
    mixins: [TitleMixin, SpinnerMixin],
    data() {
        return {
            title: this.$t("rooms.create.title"),
            id: this.$route.params.id,
            room: {},
            offices: [],
            validationOptions: {
                rules: {
                    officeId: {
                        required: true
                    },
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    capacity: {
                        required: true,
                        number: true,
                        min: 0
                    },
                    publicCapacity: {
                        required: true,
                        number: true,
                        min: 0
                    }
                }
            }
        };
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices",
            getSingleOfficeId: "account/getSingleOfficeId"
        })
    },
    methods: {
        create() {
            return this.$store.dispatch("room/create", {
                room: this.room
            });
        },
        createSuccess() {
            this.$toast.showSuccessToast(this.$t("rooms.create.toastSuccessTitle"), this.$t("rooms.create.toastSuccessContent", {
                name: this.room.name
            }));
            return this.$router.push("/administration/rooms");
        },
        cancel() {
            return this.$router.push("/administration/rooms");
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.offices = await this.$store.dispatch("office/getAll");
            if (!this.hasMultipleOffices)
                this.room.officeId = this.getSingleOfficeId;
        }
        catch (errors) {
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/administration/offices");
        }
        finally {
            this.hideSpinner();
        }
    }
});
